<template>
  <!-- 图表加载失败重试 -->
  <!-- <div
    v-show="isLoading"
    class="skeleton-loading"
    :style="{ width: width, height: height }"
  >
    <div class="skeleton-loading-text">
      <svg class="icon icon-20 btn-loading" aria-hidden="true">
        <use xlink:href="#icon-v4_loading_chart"></use>
      </svg>
      <div class="txt">加载中</div>
    </div>
  </div> -->

  <div
    v-show="loadingErr"
    class="skeleton-error"
    :style="{ width: width, height: height }"
  >
    <div class="skeleton-error-text">
      <!-- <img src="../../../assets/images/loadingError.png" alt="" /> -->
      <svg class="icon" aria-hidden="true" style="font-size: 50px">
        <use xlink:href="#icon-v4_loading_error"></use>
      </svg>
      <div>
        <span>
          <!-- 加载失败请 -->
          {{ $t("lanV4.loadingErr") }} </span
        ><span class="skeleton-error-reset" @click="onErrReset">
          <!-- 重试 -->
          {{ $t("lanV4.reset") }}
        </span>
      </div>
    </div>
  </div>
</template>
  <script>
export default {
  props: {
    loadingErr: {
      type: Boolean,
      default: false,
    },
    width: {
      type: String,
      default: "",
    },
    height: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      isLoading: false,
    };
  },
  methods: {
    // 重试
    onErrReset() {
      this.$emit("onErrReset");
    },
  },
  watch: {
    loadingErr(v) {
      this.isLoading = v;
    },
  },
};
</script>
  <style lang="scss" scoped>
.skeleton-error {
  position: absolute;
  left: 0;
  top: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  .skeleton-error-text {
    font-size: 12px;
    text-align: center;
    margin-top: -60px;
    color: #86909c;

    .skeleton-error-reset {
      color: #095be8;
      margin-left: 0px;
      cursor: pointer;
    }
  }
}
</style>